module.exports = __webpack_public_path__ + "static/fabric-persona-square-96ad489d1ed028c34e9557880ed80f00.png";